import { SearchProjects } from './constants';

const initialState = null;

export const searchProjectsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SearchProjects.searchProjectsSuccess:
      return action.data;
    default:
      return state;
  }
};
